export default __webpack_public_path__ + "static/media/gallery_01.857a3500.jpg";